/*
    View to be used when the production devicegroup list is empty.
*/

import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';

const template = `<h3>No Test Production Device Groups</h3>
To create a new Test Production Device Group, click on the Create Device Group button.`;

var PreProductionDeviceGroupListEmptyView = Marionette.View.extend({
    className: 'text-center',
    template: Handlebars.compile(template),
});

export default PreProductionDeviceGroupListEmptyView;


